import { Seo } from "./Seo";


export const PH = ({ children }) => (
  <span className="bg-street-gold/15 text-street-gold font-semibold px-1.5 py-0.5 rounded">[{children}]</span>
);

export const LegalSection = ({ n, title, children }) => (
  <section>
    <h2 className="font-display font-bold text-lg text-urban-teal mb-2">{n}. {title}</h2>
    <div className="space-y-2">{children}</div>
  </section>
);

export const LegalLayout = ({ title, path = "", updated = "JJ/MM/AAAA", children, testid }) => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid={testid}>
    <Seo title={title} path={path} description={`${title} de StreatEat, l'annuaire n°1 des foodtrucks.`} />
    <h1 className="text-3xl sm:text-4xl font-display font-extrabold text-urban-teal">{title}</h1>
    <p className="text-sm text-urban-teal/50 mt-2">Dernière mise à jour : {updated === "JJ/MM/AAAA" ? <PH>JJ/MM/AAAA</PH> : updated}</p>
    <div className="mt-8 space-y-7 text-urban-teal/80 text-sm leading-relaxed">{children}</div>
    <div className="mt-10 rounded-xl bg-cream-bg p-4 text-xs text-urban-teal/60">
      Ce document est un <b>modèle à compléter</b>. Remplacez les champs surlignés par vos informations puis faites-le valider par un professionnel du droit avant mise en ligne.
    </div>
  </div>
);
